import get from 'lodash/get'

import { STATUS_CODES } from 'utils/Constants'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { FlexDiv, P, PrimaryButton } from 'components/generic/HomePageComponents'
import SimpleErrorPage from 'components/error/SimpleErrorPage'
import ErrorPageQuery from 'components/api/queries/ErrorPageQuery.gql'
import { useQuery } from '@apollo/client'

const ERROR_IMAGE_BREAKPOINTS = ['270px', '320px', '334px']
/**
 * @export ErrorPage
 * @description Generates our 404 and 500 error pages.
 * @extends {Component}
 * @param {string} errorCode
 */
const ErrorPage = (props) => {
  const { errorCode } = props
  const { loading, error, data } = useQuery(ErrorPageQuery)
  if (loading) {
    return null
  }
  if (error) {
    return <SimpleErrorPage error={error} />
  }
  const innerHTML = { __html: get(data, 'site.errorPage.content') }
  return (
    <FlexDiv
      flexDirection='row'
      justifyContent='center'
      width='100%'
      mt={{ _: '80px', tablet: '160px' }}
      mb='80px'
    >
      <FlexDiv
        flexDirection={{ _: 'column', tablet: 'row' }}
        mt={{ _: '30px', tablet: '0px' }}
        mb={{ _: '30px', tablet: '0px' }}
        justifyContent='center'
        alignItems='center'
      >
        {
          <GenericLazyLoadImage
            src={get(data, 'site.errorPage.image.imageUrl')}
            alt={get(data, 'site.errorPage.image.imageAlt')}
            width={ERROR_IMAGE_BREAKPOINTS}
          />
        }
        <FlexDiv
          justifyContent={{ _: 'center', tablet: 'flex-start' }}
          alignItems={{ _: 'center', tablet: 'flex-start' }}
          flexDirection='column'
        >
          <P
            fontSize='55px'
            fontWeight='bold'
            color='primary.600'
            m={{ _: '0px 0px 10px 0px', tablet: '0px 0px 36.85px 20px' }}
            p='0'
            maxWidth='90vw'
          >
            {errorCode === STATUS_CODES.CODE404 ? '404 Error' : '500 Error'}
          </P>
          <P
            lineHeight='38px'
            fontSize='40px'
            m={{ _: '0px 0px 10px 0px', tablet: '0px 0px 10px 20px' }}
            p='0'
            maxWidth='90vw'
          >
            {get(data, 'site.errorPage.title')}
          </P>
          <P
            fontSize='22px'
            m={{ _: '0px 0px 10px 0px', tablet: '0px 0px 10px 20px' }}
            p='0'
            maxWidth='90vw'
            dangerouslySetInnerHTML={innerHTML}
          />
          {errorCode === STATUS_CODES.CODE404 && (
            <FlexDiv
              flexDirection={{ _: 'column', tablet: 'row' }}
              justifyContent={{ _: 'flex-start', tablet: 'justify-center' }}
              mt='40px'
              ml='20px'
              mb={{ _: '30px', tablet: '0px' }}
            >
              <PrimaryButton
                mr='10px'
                mb='10px'
                fontSize='18px'
                height='2.75vh'
                href={`${get(data, 'site.errorPage.jobsLink.link')}`}
              >
                {get(data, 'site.errorPage.jobsLink.text')}
              </PrimaryButton>
              <PrimaryButton
                fontSize='18px'
                height='2.75vh'
                href={`${get(data, 'site.errorPage.profilesLink.link')}`}
              >
                {get(data, 'site.errorPage.profilesLink.text')}
              </PrimaryButton>
            </FlexDiv>
          )}
        </FlexDiv>
      </FlexDiv>
    </FlexDiv>
  )
}
export default ErrorPage
